import styled from 'styled-components';

export const Top = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 10px;

  transform: translateY(-50%);

  cursor: n-resize;
`;
